// import 'core-js';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'intersection-observer'; // necessary for react-hook-inview

import React from 'react';
import { render } from 'react-dom';
import queryString from 'query-string';
import './styles.scss';

import App from './app';

const parsed = queryString.parse(window.location.search);

/**
 * El formulario de Solicitud de Tarjetas se carga dentro de la landing de Tarjetas.
 *
 * URL: /inst/tarjetas.html
 * Carga la landing como siempre.
 *
 * URL: /inst/tarjetas.html?grupo=volar&tipo=internacional
 * Carga la landing con el formulario abierto.
 *
 * Si falta alguno de los dos parámetros (grupo & tipo) entonces no carga el formulario.
 * Al cargar el formulario, el contexto de la página se oculta, pero no se remueve.
 *
 * Este script se encarga de:
 *  1. Chequear que los parámetros en la URL estén presentes
 *  2. En caso de estar, ocultar el contexto y renderizar el formulario
 *  3. En caso contrario, se muestra la landing tal cual estaba
 *
 * Dentro del formulario, el logo de Steps cierra el formulario para volver a la landing.
 */

function hideSafely(selector) {
  let el = document.querySelector(selector);
  if (el) el.style.display = 'none';
}

// const grupos = ['volar', 'latam', 'on', 'benefits'];
const grupos = ['volar', 'latam', 'on'];
const tipos = ['internacional', 'platinum'];
// const tipos = ['regional', 'internacional', 'oro'];

function hasValidParams() {
  return (
    parsed.grupo && parsed.tipo && grupos.includes(parsed.grupo) && tipos.includes(parsed.tipo)
  );
}

/**
 * Mostrar el formulario
 */
function showForm() {
  if (hasValidParams()) {
    hideSafely('.wrapper_body');
    hideSafely('body > header');
    hideSafely('.main-tarjetas');

    document.addEventListener('DOMContentLoaded', () => {
      hideSafely('footer');
      hideSafely('#btnOpenChat');
    });

    render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      document.getElementById('itau-tc'),
    );
  }
}

// Si ya viene con los parámetros válidos, mostrar el formulario
if (hasValidParams()) {
  showForm();
}

// Ocultar el spinner al final de todo
hideSafely('.js-loader');
